if (!customElements.get('ways-to-buy')) {
  customElements.define(
    'ways-to-buy',
    class WaysToBuy extends HTMLElement {
      constructor() {
        super();
        this.currentOption = this.querySelector('[data-ways-to-buy-type="current"]');
        this.linkedOption = this.querySelector('[data-ways-to-buy-type="linked"]');
        this.init();
      }

      init() {
        document.addEventListener('variant:change', this.onVariantChange.bind(this));
      }

      onVariantChange(event) {
        const variantId = event.detail?.variant?.id;
        if (!variantId) return;

        const variantData = window.waysToBuyVariantMap?.[variantId];
        if (!variantData) return;

        this.updateCurrentOption(variantData);
        this.updateLinkedOption(variantData.linkedVariant);
      }

      updateCurrentOption(variant) {
        if (!this.currentOption) return;

        const priceEl = this.currentOption.querySelector('.ways-to-buy__price-container');
        if (priceEl) {
          priceEl.innerHTML = this.getPriceHtml(variant.price, variant.compareAtPrice);
        }
        this.currentOption.classList.toggle('ways-to-buy__option--unavailable', !variant.available);
      }

      updateLinkedOption(linked) {
        if (!this.linkedOption) return;

        if (linked) {
          this.linkedOption.href = linked.url;
          this.linkedOption.classList.remove('ways-to-buy__option--disabled');
          this.linkedOption.classList.toggle('ways-to-buy__option--unavailable', !linked.available);
          
          const priceEl = this.linkedOption.querySelector('.ways-to-buy__price-container');
          if (priceEl) {
            priceEl.innerHTML = this.getPriceHtml(linked.price, linked.compareAtPrice);
          }
        } else {
          this.linkedOption.removeAttribute('href');
          this.linkedOption.classList.add('ways-to-buy__option--disabled', 'ways-to-buy__option--unavailable');
          
          const priceEl = this.linkedOption.querySelector('.ways-to-buy__price-container');
          if (priceEl) {
            priceEl.innerHTML = '<span class="ways-to-buy__option-price">—</span>';
          }
        }
      }

      getPriceHtml(price, compareAtPrice) {
        const formatPrice = (cents) => Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
        
        if (compareAtPrice && compareAtPrice > price) {
          return `<span class="ways-to-buy__option-compare-price">${formatPrice(compareAtPrice)}</span><span class="ways-to-buy__option-sale-price">${formatPrice(price)}</span>`;
        }
        return `<span class="ways-to-buy__option-price">${formatPrice(price)}</span>`;
      }
    }
  );
}
